<template>
  <div class="w-100">
    <div class="mt-3 d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
          style="z-index: 1"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('about')">Sobre</strong>
          </h2>
          <p class="d-flex align-items-center">
            <span
              v-if="!view"
              class="align-self-center"
              v-text="$ml.get('aboutPentest')"
            >
              Defina a finalidade do Pentest, destacando os riscos e
              vulnerabilidades que devem ser avaliados.
            </span>
            <span
              v-else
              class="align-self-center"
              v-text="$ml.get('summaryAboutPentest')"
            >
              Resumo da finalidade do Pentest, destacando os riscos e
              vulnerabilidades que devem ser avaliados.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <!-- Tipo de pentest -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100">
        <div class="row w-100 d-flex pl-3">
          <div class="col-24">
            <div class="form-group">
              <label v-if="view" v-text="$ml.get('briefApplicationPurpose')"
                >Uma breve descrição do propósito da aplicação</label
              >
              <label v-else v-text="$ml.get('appPurposeDescription')"
                >Faça uma breve descrição do propósito da aplicação</label
              >
              <div v-if="view" class="card">
                <div class="card-body d-flex flex-column w-100">
                  <div class="form-control h-100">
                    <p v-html="summaryPentent"></p>
                  </div>
                </div>
              </div>
              <div v-else>
                <form>
                  <div class="col">
                    <svg
                      v-show="!htmlText"
                      @click="viewHtml()"
                      width="24"
                      height="24"
                      class="ico-view-report"
                    >
                      <image
                        xlink:href="../../../assets/icons/eye.svg"
                        width="24"
                        height="24"
                      />
                    </svg>
                    <svg
                      v-show="htmlText"
                      @click="htmlText = ''"
                      width="24"
                      height="24"
                      class="ico-view-report"
                    >
                      <image
                        xlink:href="../../../assets/icons/eye-slash.svg"
                        width="24"
                        height="24"
                      />
                    </svg>

                    <textarea
                      v-show="!htmlText"
                      class="form-control-textarea w-100 text-are-mark"
                      v-model="summaryPentent"
                      ref="textarea"
                      :placeholder="$ml.get('moreDetailsAboutYourApp')"
                      rows="5"
                      maxlength="300"
                    >
                    </textarea>
                    <div
                      v-if="!htmlText"
                      :class="[
                        'col',
                        'd-flex',
                        error
                          ? 'justify-content-between'
                          : 'justify-content-end',
                      ]"
                    >
                      <div v-if="error">
                        <label
                          class="lblError"
                          v-text="$ml.get('fillAppDetails')"
                          >Preencha os detalhes da aplicação *
                        </label>
                      </div>

                      <span
                        style="
                          font-size: 12px;
                          color: rgb(82, 82, 82);
                          font-weight: 400;
                        "
                        >{{ $ml.get("characters") }}
                        {{ summaryPentent.length }}/300</span
                      >
                    </div>
                    <div
                      v-show="htmlText"
                      class="form-control w-100 h-100"
                      v-html="htmlText"
                    ></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Presencial ou remoto -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3 mb-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24">
            <div class="form-group">
              <label v-text="$ml.get('aboutApplication')"
                >Sobre aplicação</label
              >

              <div
                v-if="view"
                class="d-flex align-items-center p-0 mt-2"
                style="gap: 10px"
              >
                <svg v-if="aboutCriticalApplication" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <label>
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('criticalApplicationDescription')"
                    >Trata-se de uma aplicação crítica, onde falhas podem
                    colocar vidas em risco.</strong
                  >
                  <br />
                  <span
                    style="font-size: 12px"
                    v-text="$ml.get('criticalSystemsExamples')"
                  >
                    Sistemas de usinas nucleares, aviônicos, controle industrial
                    e automação hospitalar.
                  </span>
                </label>
              </div>

              <div v-else class="custom-control custom-checkbox mt-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="aboutCriticalApplication"
                  style="height: 15px; width: 15px"
                />
                <label class="custom-control-label">
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('criticalApplicationWarning')"
                    >Trata-se de uma aplicação crítica, onde falhas podem
                    colocar vidas em risco.</strong
                  >
                  <br />
                  <span
                    style="font-size: 12px"
                    v-text="$ml.get('criticalSystemsExamples')"
                  >
                    Sistemas de usinas nucleares, aviônicos, controle industrial
                    e automação hospitalar.
                  </span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <div
                v-if="view"
                class="d-flex align-items-center p-0 mt-2"
                style="gap: 10px"
              >
                <svg v-if="aboutHandleLargeVolumes" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <label>
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('criticalApplicationWarning')"
                    >Trata-se de uma aplicação crítica, onde falhas podem
                    colocar vidas em risco.</strong
                  >
                  <br />
                  <span
                    style="font-size: 12px"
                    v-text="$ml.get('criticalSystemsExamples')"
                  >
                    Sistemas de usinas nucleares, aviônicos, controle industrial
                    e automação hospitalar.
                  </span>
                </label>
              </div>
              <div v-else class="custom-control custom-checkbox mt-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="aboutHandleLargeVolumes"
                  style="height: 15px; width: 15px"
                />
                <label class="custom-control-label">
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('handlesLargePersonalDataVolumes')"
                    >Manipula grandes volumes de dados pessoais.</strong
                  >
                </label>
              </div>
            </div>
            <div class="form-group">
              <div
                v-if="view"
                class="d-flex align-items-center p-0 mt-2"
                style="gap: 10px"
              >
                <svg v-if="aboutFinancialTransactions" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <label>
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('criticalApplicationWarning')"
                    >Trata-se de uma aplicação crítica, onde falhas podem
                    colocar vidas em risco.</strong
                  >
                  <br />
                  <span
                    style="font-size: 12px"
                    v-text="$ml.get('criticalSystemsExamples')"
                  >
                    Sistemas de usinas nucleares, aviônicos, controle industrial
                    e automação hospitalar.
                  </span>
                </label>
              </div>
              <div v-else class="custom-control custom-checkbox mt-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="aboutFinancialTransactions"
                  style="height: 15px; width: 15px"
                />
                <label class="custom-control-label">
                  <strong
                    style="font-size: 14px"
                    v-text="$ml.get('performsFinancialTransactions')"
                    >Executa transações financeiras.</strong
                  >
                  <br />
                  <span
                    style="font-size: 12px"
                    v-text="$ml.get('paymentsCryptoAssetsSwiftTransactions')"
                  >
                    Pagamentos, criptoativos e transações Swift.
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ConfigPentest",
  props: {
    number: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
    },
    view: {
      type: Boolean,
      required: false,
    },
    dataPentest: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      htmlText: "",
      summaryPentent: "",
      aboutCriticalApplication: false,
      aboutHandleLargeVolumes: false,
      aboutFinancialTransactions: false,
    };
  },
  methods: {
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.summaryPentent);
    },
  },

  watch: {
    summaryPentent() {
      this.$emit(
        "getSummaryPentest",
        this.$utils.convertMarkedOld(this.summaryPentent),
      );
    },

    aboutCriticalApplication() {
      this.$emit("getAboutCriticalApplication", this.aboutCriticalApplication);
    },
    aboutHandleLargeVolumes() {
      this.$emit("getAboutHandleLargeVolumes", this.aboutHandleLargeVolumes);
    },
    aboutFinancialTransactions() {
      this.$emit(
        "getAboutFinancialTransactions",
        this.aboutFinancialTransactions,
      );
    },

    // modo visualização
    dataPentest: {
      handler() {
        this.summaryPentent = this.dataPentest.aboutDescription;
        this.aboutCriticalApplication =
          this.dataPentest.aboutCriticalApplication;

        this.aboutHandleLargeVolumes = this.dataPentest.aboutHandleLargeVolumes;
        this.aboutFinancialTransactions =
          this.dataPentest.aboutFinancialTransactions;
      },
      deep: true,
    },
  },
};
</script>
